import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import Boton from '@/components/elements/Boton';
import { primary, white } from '@/constants/Colors';
import { Card } from '@mui/material';
import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import { subtitulo } from '@/constants/Dimens';
import Subtitulo from '@/components/elements/Subtitulo';
import Texto from '@/components/elements/Texto';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Productos, pago_producto } from '@/util/Stripe';
import { LoginDatos, ResultadoCodigo } from '@/objects/User';
import TextFieldCustom, { InputTypes } from '@/components/elements/TextFieldCustom';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import StarsIcon from '@mui/icons-material/Stars';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { mostrarAlerta } from '@/context/UtilsContext';
import { reproducirSonido } from '@/util/Sound';
import { comprobarLogro } from '@/util/Gamificacion';
import { IndiceLogro } from '@/objects/Gamificacion';
import { useNotificationContext } from '@/context/NotificationContext';
import { urlWeb } from '@/util/BaseURL';

export enum ModoMisLibros {
    MIS_LIBROS = "mis_libros",
    BUSCAR = "buscar"
}

function Creditos() {

    const { usersQueries, gamificationQueries } = useServices();
    const { userData } = useNotificationContext();

    const [creditos, setCreditos] = React.useState<string>();

    const [codigo, setCodigo] = React.useState<string>();

    const { t } = useTranslation();

    useEffect(() => {
        cargarDatos();
    }, []);

    function cargarDatos() {
        //Lo obtiene usando el token
        usersQueries?.obtenerDatosUsuario().then((response: AxiosResponse<LoginDatos>) => {
            const creditos = response.data.points;
            //alert(fechaPremium)
            setCreditos(String(creditos));
        }
        );
    }

    function comprar(producto: Productos) {
        pago_producto(producto, `${urlWeb}/dashboard/conseguir-creditos`, `${urlWeb}/dashboard/conseguir-creditos`, userData?.email!);
    }

    function canjearCodigo() {
        if (codigo == undefined || codigo == "") {
            return;
        }

        const datosUsuario = cargarDatosUsuario();
        usersQueries?.canjearCodigo(Number(datosUsuario?.id_user), String(codigo)).then((response: AxiosResponse<ResultadoCodigo>) => {
            if (response.status == 200) {
                if (response.data.tipo_premio == "creditos") {
                    const creditosConseguidos = response.data.valor;
                    setCreditos(String(creditosConseguidos));
                    mostrarAlerta({
                        title: t('common:opciones.informacion'),
                        content: t('menu:secciones.conseguir_creditos.codigo_canjeado_correctamente', { creditos: creditosConseguidos }),
                    });
                    //Suma los creditos a los anteriores
                    reproducirSonido("COMPRAS");
                    setCreditos(String(Number(creditos) + creditosConseguidos));
                    comprobarLogro(IndiceLogro.CODIGO_BY_THE_FACE, gamificationQueries!, t, true);
                }
                setCodigo("");
            }
        }).catch((error) => {
            console.log('Error en canjearCodigo', error);
            if (error.response?.status === 404) {
                const detail_error = error.response?.data?.detail;

                if (detail_error === "Código no encontrado.") {
                    mostrarAlerta({
                        title: t('common:opciones.error'),
                        content: t('menu:secciones.conseguir_creditos.codigo_no_valido'),
                    });
                }
                if (detail_error === "Código ya canjeado por este usuario.") {
                    mostrarAlerta({
                        title: t('common:opciones.error'),
                        content: t('menu:secciones.conseguir_creditos.codigo_usado'),
                    });
                }
            }
        });
    }

    const cardStyle = {
        padding: "20px",
        animation: "pulse 2s 4",
        margin: "10px",
    }

    const separacionVentajas = {
        marginTop: "10px",
        marginBottom: "10px"
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TituloPrincipalH1 texto={t("menu:secciones.conseguir_creditos.titulo")} />

            <TituloSeccionH2 fontSize={subtitulo} texto={t("menu:secciones.conseguir_creditos.descripcion")} />

            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                <Card style={{ ...cardStyle, textAlign: 'center' }}>
                    <Texto>{t("menu:secciones.conseguir_creditos.tienes_creditos", { creditos: creditos })}</Texto>
                </Card>
                <Card style={cardStyle}>
                    <div>
                        <Subtitulo texto={t("menu:secciones.conseguir_creditos.texto_creditos")} />
                        <div style={separacionVentajas}>
                            <Texto>{t("menu:secciones.conseguir_creditos.puedes_conseguir_creditos")}</Texto>
                        </div>
                    </div>
                    <div>
                        <Texto>{t("menu:secciones.conseguir_creditos.las_compras")}</Texto>
                        <div style={separacionVentajas}>
                            <Boton color={primary} fullWidth colorTexto={white} startIcon={<ShoppingCartIcon />}
                                texto={t("menu:secciones.conseguir_creditos.creditos_por", { creditos: "100", precio: "0,98", simbolo_moneda: "€" })}
                                onClick={() => { comprar(Productos.CREDITOS_100) }} />
                        </div>
                        <div style={separacionVentajas}>
                            <Boton color={primary} fullWidth colorTexto={white} startIcon={<ShoppingCartIcon />}
                                texto={t("menu:secciones.conseguir_creditos.creditos_por", { creditos: "500", precio: "3,99", simbolo_moneda: "€" })}
                                onClick={() => { comprar(Productos.CREDITOS_500) }} />
                        </div>
                    </div>
                </Card>
                <Card style={cardStyle}>
                    <div>
                        <Subtitulo texto={t("menu:secciones.conseguir_creditos.canjear_codigo")} />
                        <div style={separacionVentajas}>
                            <Texto>{t("menu:secciones.conseguir_creditos.con_el_codigo")}</Texto>
                        </div>
                    </div>
                    <div>
                        <div style={separacionVentajas}>
                            <Texto>{t("menu:secciones.conseguir_creditos.canjear_codigo")} </Texto>
                            <TextFieldCustom id="promo_code" label={t('menu:secciones.conseguir_creditos.introduce_el_codigo')} value={codigo} setValue={setCodigo}
                                required={false} inputType={InputTypes.Text}
                                leftIcon={<MonetizationOnIcon />} />
                            <Boton color={primary} fullWidth colorTexto={white} startIcon={<StarsIcon />}
                                texto={t("menu:secciones.conseguir_creditos.canjear", { creditos: "100", precio: "0,98", simbolo_moneda: "€" })}
                                onClick={() => { canjearCodigo(); }} />
                        </div>

                    </div>
                </Card>
            </section>

        </section>
    );
}

/* <Boton color={white} colorTexto={primary} startIcon={<AccessAlarmsIcon />} texto={t("menu:secciones.mis_libros.destacar_todos_los_libros")} onClick={() => { destacarTodos() }} />*/
export default Creditos;